import { ProductTicketTPVDSBProps } from '../..'
import SellTicketFinishedStep from '../SellTicketFinishedStep'
import SellTicketPartialChargedStepButtons from './SellTicketPartialChargedStepButtons'

type SellTicketPartialChargedStepProps = ProductTicketTPVDSBProps & {}

const SellTicketPartialChargedStep: React.FC<SellTicketPartialChargedStepProps> = ({ completeData, ...rest }) => {
    return (
        <SellTicketFinishedStep {...{ completeData, TableButtons: SellTicketPartialChargedStepButtons, ...rest } } />
    )
}

export default SellTicketPartialChargedStep